import { Text } from '@frontend/design-system';

type ItemProps<T extends object> = {
  label: string;
  value?: string | React.ReactNode | T[keyof T];
};

export const Item = <T extends object>({ label, value }: ItemProps<T>) => (
  <div>
    <Text size='small' color='subdued'>
      {label}
    </Text>
    <Text
      css={{
        maxWidth: 160,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
      }}
    >
      {value ?? '-'}
    </Text>
  </div>
);
